import dictionary from './dictionary.json';

type Dictionary = typeof dictionary;
type DictionaryKey = keyof Dictionary;

export const i18n = (key: DictionaryKey, forcedLanguage: string | undefined = undefined): string => {
  const language = getLanguage(forcedLanguage);
  const dictionaryEntry = dictionary[key] as { [key: string]: string };

  if (!language || !dictionaryEntry[language]) {
    return `??${key}??`;
  }

  return dictionaryEntry[language];
};

const getLanguage = (forcedLanguage: string | undefined) => {
  if (forcedLanguage) {
    return forcedLanguage;
  } else {
    return document.querySelector('html')?.getAttribute('lang') || undefined;
  }
};
